<div [style.height.px]="52">
  <div nz-row nzAlign="middle">
    <span
      nz-col
      nz-checkbox
      [nzChecked]="value.enabled"
      (nzCheckedChange)="onCheckboxChange($event)"
    >
      {{ label() | translate }}
    </span>

    <moxi-inline-input-control
      [label]="label() | translate"
      [cssClass]="'dashed-border'"
      [isNumber]="true"
      [maxValue]="15"
      [minValue]="3"
      [inputWidth]="inputWidth()"
      (valueChange)="onTextChange($event)"
    />
  </div>
</div>
